<div class="flex flex-col gap-5" [attr.data-test-id]="`expert-responded-detail-expert-${expert.expertId}`">
  <h1 data-test-id="expert-responded-dialog-expert-name">{{ expert | expertName }}</h1>
  <div class="flex flex-col gap-[5px]">
    <label class="label" data-test-id="expert-responded-dialog-expert-primary-email-label">
      Point of contact email
    </label>
    @if (!expert.primaryEmail) {
      <p class="danger" data-test-id="expert-responded-dialog-expert-primary-email-error">Please select an email</p>
    }
    <ul class="horizontal-list">
      @for (email of emailList; track email) {
        <li class="email-pill horizontal-list-item" (click)="selectPocEmail(email)">
          <app-shared-contact-info-pill
            data-test-id="expert-responded-detail-expert-email"
            label="Point of contact"
            [contact]="email"
            [selected]="expert.primaryEmail === email"
          >
          </app-shared-contact-info-pill>
        </li>
      }
    </ul>
  </div>

  @if (targetPhaseIndex >= 5 || !expert.expertSegment) {
    <mat-form-field appearance="fill" class="basis-[23%]">
      <mat-label data-test-id="expert-responded-detail-expert-segment-label"> Expert segment </mat-label>
      @if (!expert.expertSegment) {
        <mat-error data-test-id="expert-responded-detail-select-expert-segment-error">
          Please select a segment
        </mat-error>
      }
      <mat-select data-test-id="expert-responded-detail-expert-segment" [formControl]="expertSegmentControl">
        @for (segment of segments; track segment) {
          <mat-option data-test-id="expert-responded-detail-expert-segment-option" [value]="segment">
            {{ segment | expertSegment }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (targetPhaseIndex >= 6) {
      <app-currency-input
        data-test-id="expert-responded-detail-expert-currency"
        [formControl]="currencyFormControl"
        [isInvalid]="currencyFormControl.hasError('missingCurrency') || currencyFormControl.hasError('invalidCurrency')"
      >
      </app-currency-input>
      <mat-form-field>
        <mat-label data-test-id="expert-responded-detail-cost-band-label">Cost band</mat-label>
        <mat-select data-test-id="expert-responded-detail-cost-band" [formControl]="costBandControl">
          @for (option of costBandOptions; track option) {
            <mat-option data-test-id="expert-responded-detail-cost-band-option" [value]="option">
              {{ option }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (!isCostBandStandard) {
        <mat-form-field>
          <mat-label data-test-id="expert-responded-detail-unit-rate-label">Unit cost per hour</mat-label>
          <input
            matInput
            type="number"
            step="0.01"
            placeholder="1.00"
            data-test-id="expert-responded-detail-unit-rate"
            [formControl]="unitsPerHourControl"
          />
          @if (unitsPerHourControl.invalid) {
            <mat-error data-test-id="expert-responded-detail-unit-rate-error">
              Please enter valid unit cost per hour
            </mat-error>
          }
        </mat-form-field>
      }
    }
    <div class="flex flex-col gap-[5px]">
      <label class="label" data-test-id="expert-responded-detail-expert-opportunity-segment-label">
        Geographic target and profile type
      </label>
      @if (!expert.geographicTarget || !expert.profileType) {
        <p class="danger" data-test-id="expert-responded-detail-expert-opportunity-segment-error">
          Please select a geographic target and profile type
        </p>
      }
      <div class="country-zone-input">
        <div class="country-zone-input-selects">
          <div class="basicInput">
            <mat-form-field appearance="fill" class="basis-[23%]">
              <mat-label data-test-id="expert-responded-detail-expert-opportunity-segment-geography-label">
                Select geographic target
              </mat-label>
              <mat-select
                data-test-id="expert-responded-detail-expert-opportunity-segment-geography"
                [(ngModel)]="expert.geographicTarget"
                (selectionChange)="assignTargetGeography($event.value)"
              >
                @for (target of targetGeos; track target) {
                  <mat-option
                    data-test-id="expert-responded-detail-expert-opportunity-segment-geography-option"
                    [value]="target"
                  >
                    {{ target }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <span class="country-zone-input-chevron">
            <mat-icon>chevron_right</mat-icon>
          </span>
          @if (profileOptions) {
            <div class="basicInput">
              <mat-form-field appearance="fill" class="basis-[23%]">
                <mat-label data-test-id="expert-responded-detail-expert-opportunity-segment-profile-type-label">
                  Select profile type
                </mat-label>
                <mat-select
                  data-test-id="expert-responded-detail-expert-opportunity-segment-profile-type"
                  [(ngModel)]="expert.profileType"
                  (selectionChange)="assignTargetGeography(expert.geographicTarget, $event.value)"
                >
                  @for (segment of profileOptions; track segment) {
                    <mat-option
                      data-test-id="expert-responded-detail-expert-opportunity-segment-profile-option"
                      [value]="segment"
                    >
                      {{ segment | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
